package features.attendance.domain

data class AttendanceRecord(
    val id: Int,
    val userId: String,
    val date: String,
    val checkIn: String,
    val checkOut: String,
    val status: String,
    val location: String,
    val checkInPhoto: String? = null,
    val checkOutPhoto: String? = null
)
